module.exports = __webpack_public_path__ + "img/sindinor.b2c1759f.png";